<template>
    <div class="box my-3 pl-0 pr-3 py-0">

        <div class="columns mx-0 my-0 is-vcentered has-background-eduloc-red">
            <div class="column is-narrow px-3">
                <span class="has-text-white icon is-large">
                    <i class="mdi-paw mdi mdi-18px bigger"></i>
                </span>
            </div>

            <div class="column has-background-white px-0 py-0 self-align">

                <p class="has-text-black is-size-6 px-5 py-5 secondary-font" v-html="question.description"></p>


            </div>
            <div class="column is-narrow has-background-white">

                <div class="">
                    <p class="is-size-5 has-text-eduloc-red has-text-right">
                        {{ question.hitRate }}&nbsp;{{ $t('Sessions.question_hit_rate') }}
                    </p>

                </div>

                <div class="columns is-mobile pt-4">
                    <div class="column is-3">
                        <figure class="image is-48x48 is-centered">
                            <img src="@/assets/images/help.svg">
                        </figure>
                        <p class="is-size-7 has-text-centered helper pt-2">{{ $t('Sessions.helpers.nothing') }}</p>
                        <p class="is-size-5 has-text-centered">{{ assistance.nothing }}</p>
                    </div>
                    <div class="column is-3">
                        <figure class="image is-48x48 is-centered">
                            <img src="@/assets/images/compass.svg">
                        </figure>
                        <p class="is-size-7 has-text-centered helper pt-2">{{ $t('Sessions.helpers.with_compass') }}</p>
                        <p class="is-size-5 has-text-centered">{{ assistance.compass }}</p>
                    </div>
                    <div class="column is-3">
                        <figure class="image is-48x48 is-centered">
                            <img src="@/assets/images/distance.svg">
                        </figure>
                        <p class="is-size-7 has-text-centered helper pt-2">{{ $t('Sessions.helpers.with_distance') }}</p>
                        <p class="is-size-5 has-text-centered">{{ assistance.distance }}</p>
                    </div>
                    <div class="column is-3">
                        <figure class="image is-48x48 is-centered">
                            <img src="@/assets/images/compass_distance.svg">
                        </figure>
                        <p class="is-size-7 has-text-centered helper pt-2">
                            {{ $t('Sessions.helpers.with_compass_and_distance') }}</p>
                        <p class="is-size-5 has-text-centered">{{ assistance.all }}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!--<div class="lb-question-answers">
                    <div class="is-relative pl-4 is-bordered pt-1 pb-1">
                        <div class="level is-mobile is-relative">
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="py-2">
                                        <span
                                            class="
                                                is-size-5
                                                has-text-weight-bold
                                            "
                                            >{{ assistance.nothing }}
                                        </span>
                                        <span class="has-text-weight-bold">{{
                                            $t('Sessions.helpers.nothing')
                                        }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="level-right"></div>
                        </div>
                    </div>
                    <div class="is-relative pl-4 is-bordered pt-1 pb-1">
                        <div class="level is-mobile is-relative">
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="py-2">
                                        <span class="is-size-5"
                                            >{{ assistance.compass || 0 }}
                                        </span>
                                        <span class="">{{
                                            $t('Sessions.helpers.with_compass')
                                        }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="level-right"></div>
                        </div>
                    </div>

                    <div class="is-relative pl-4 is-bordered pt-1 pb-1">
                        <div class="level is-mobile is-relative">
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="py-2">
                                        <span class="is-size-5"
                                            >{{ assistance.distance || 0 }}
                                        </span>
                                        <span class="">{{
                                            $t('Sessions.helpers.with_distance')
                                        }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="level-right"></div>
                        </div>
                    </div>

                    <div class="is-relative pl-4 is-bordered pt-1 pb-1">
                        <div class="level is-mobile is-relative">
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="py-2">
                                        <span class="is-size-5"
                                            >{{ assistance.all || 0 }}
                                        </span>
                                        <span class="">{{
                                            $t(
                                                'Sessions.helpers.with_compass_and_distance'
                                            )
                                        }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="level-right"></div>
                        </div>
                    </div>
                </div>-->
</template>

<script>
import _ from 'underscore';
export default {
    props: {
        question: {
            type: Object,
            default: () => { },
        },
        userAnswer: {
            type: [Array, String],
            default: () => {
                return [];
            },
        },
        correctAnswersCount: {
            type: Number,
            default: 0,
        },
        incorrectAnswersCount: {
            type: Number,
            default: 0,
        },
        assistance: {
            type: Object,
            default: () => {
                return { compass: 0, distance: 0, nothing: 0, all: 0 };
            },
        },
    },
    data() {
        return {};
    },
    computed: {
        questionImage() {
            return this.question.images && this.question.images.length
                ? this.question.images[0].url
                : process.env.VUE_APP_ROOT_URL + '/img/empty.png';
        },
        totalAnswers() {
            return _.chain(this.question.stats)
                .values()
                .reduce((memo, num) => {
                    return memo + +num;
                }, 0)
                .value();
        },
        answerSelectedByUser() {
            return (answer) => {
                if (this.question.answerType == 'MULTIPLE') {
                    return !!_.where(this.userAnswer, answer).length;
                } else {
                    return answer.value == this.userAnswer;
                }
            };
        },
        background() {
            return `background-image:url(${this.questionImage});background-size:cover;background-repeat: no-repeat; background-position: center;`;
        },
    },

    methods: {},
    mounted() {
        // console.log(this.assistance, this.assistance.nothing);
    },
};
</script>

<style scoped>
img {
    object-fit: cover;
}

.lb-question-image {
    width: 270px;
    height: 160px;
}

.lb-question-container {
    align-items: flex-start;
    display: flex;
}

@media only screen and (max-width: 768px) {
    .lb-question-container {
        display: initial;
    }

    .lb-question-image {
        width: 100%;
        height: 160px;
    }
}

.lb-question-container>figure {
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
}

.lb-question-container>.lb-question-answers {
    flex-basis: auto;
    flex-grow: 1;
    flex-shrink: 1;
}

.questions-progress {
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    position: absolute;
}

.box {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
}

.is-bordered {
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
}

.is-vertical-center {
    vertical-align: middle;
}

.lb-hangman-input-letter {
    height: auto;
}

.is-freetext {
    height: 3.3rem;
}

.has-fixed-height {
    height: 160px;
}

.image.is-centered{
    margin: 0 auto;
}
</style>
